 
import React, { useEffect } from 'react'

import { Hydrate } from '@tanstack/react-query'
import { unstable_batchedUpdates } from 'react-dom'
import { Provider as ReduxProvider } from 'react-redux'

import { wrapper } from '../redux/store'

import { useRouteTransition, useSendInteractionToNewRelic } from 'hooks'
import Provider from 'providers'

import { FullScreenLoader } from 'components/v2/FullScreenLoader'
import { Notification } from 'components/v2/Notification'
import { VittudeCareForm } from 'components/v2/VittudeCareForm'

import { GlobalStyle } from 'utils/theme'


import 'font-awesome/css/font-awesome.min.css'

import '../styles/tw-globals.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-dates/lib/css/_datepicker.css'
import 'rc-time-picker/assets/index.css'

function App({ Component, pageProps, err, router }) {
  useSendInteractionToNewRelic()

  // TODO: Remover após migrar os forms para react-hook-form - FRE-587
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.unstable_batchedUpdates = unstable_batchedUpdates
    }
  }, [])
  const { isTransitioning } = useRouteTransition()
  const { store, props } = wrapper.useWrappedStore(pageProps)

  return (
    <ReduxProvider store={store}>
      <Provider>
        <Hydrate state={pageProps.dehydratedState}>
          <VittudeCareForm formId='DB1qXg5' />
          {isTransitioning && <FullScreenLoader />}
          <Component {...pageProps} {...props} err={err} url={{ ...router }} />
          <Notification />
          <GlobalStyle />
        </Hydrate>
      </Provider>
    </ReduxProvider>
  )
}

export default App
